import React from "react";
import {
  View,
  StyleSheet,
  ImageBackground,
  TouchableOpacity,
} from "react-native";
import Text from "components/Text";
import ImgIcon from "components/imgIcon";

import { shapes } from "assets/shapes";
import { icons } from "assets/icons";

export default function HomeItemBox(props: {
  title: string;
  imgIcon: ImgIconT;
  onAdd: () => void;
  onPress: () => void;
}) {
  const { imgIcon, title, onAdd, onPress } = props;

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={onAdd}
        activeOpacity={0.9}
        style={styles.plusButton}
      >
        <ImgIcon icon={icons.plus} size={"100%"} />
      </TouchableOpacity>

      <ImageBackground
        source={shapes.homeItemBox}
        style={styles.imageBackground}
      >
        <ImgIcon {...imgIcon} size="35%" style={styles.icon} />
      </ImageBackground>
      <Text weight="extraBold" size={"lg"} style={styles.title} align="center">
        {title}
      </Text>
      <TouchableOpacity
        onPress={onPress}
        activeOpacity={0.9}
        style={styles.detailsTouchArea}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { width: "100%" },

  imageBackground: {
    width: "100%",
    aspectRatio: 1,
    alignItems: "center",
    justifyContent: "center",
  },

  icon: { marginBottom: "5%" },

  plusButton: {
    width: "27%",
    aspectRatio: 1,
    position: "absolute",
    left: "4.5%",
    zIndex: 200,
  },

  title: { width: "100%", marginTop: -5 },

  detailsTouchArea: {
    width: "80%",
    alignSelf: "center",
    height: "80%",
    bottom: "-10%",
    position: "absolute",
  },
});
